import styled from 'styled-components';
import { CollectScreen } from '../templates/screens/CollectScreen';
import { ConsentsContainer } from '../templates/common-components/Consents.style';
import { StyledCtaButton } from '../templates/common-components/CtaButton.style';
import { DeclineCtaButton } from '../templates/screens/CollectScreen.style';
import { HTMLContainer } from '../templates/common-components/HtmlZone.style';

interface Props {
	suOptinForm?: boolean;
}

export const SmartOptinsForm = styled(CollectScreen)<Props>`
  ${HTMLContainer} {
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
  }

  ${ConsentsContainer} {
    top: 56vh;
    height: 25vh;

  	${(props): string => (props.suOptinForm === true ? 'height: 20vh;' : '')}
  }
  
  ${DeclineCtaButton} {
    top: 83vh;
	color: white;
  }
  
  ${StyledCtaButton} {
    height: 7vh;
    left: 15vh;
    right: 15vh;

	${(props): string => (props.suOptinForm === true ? 'bottom: 15vh;' : '')}
  }
`;
